import React from 'react';

import { SecondIFrameStateProvider } from 'rcx_crm_ui';
import ReactDOM from 'react-dom/client';

import { ServiceNowAdapter } from './adapter';
import App from './App';
import setup from './setup';

window.rcServiceNowAdapter = new ServiceNowAdapter({
    config: {
        version: '0.0.1',
    },
    openFrameInitCallback: () => {
        const root = ReactDOM.createRoot(window.document.body);
        root.render(
            <SecondIFrameStateProvider>
                <App />
            </SecondIFrameStateProvider>
        );
    },
});

setup();
